import getOwnKeys from './getOwnKeys';
import uniq from './uniq';

/**
 * filterに設定して重複を取り除く。
 *
 * @param values
 * @returns
 */
export default function eqLoose(v1: unknown, v2: unknown): boolean {
  // null、undefinedは同様に扱う。
  if (v1 === null || v2 === null || v1 === undefined || v2 === undefined) {
    return (v1 === null || v1 === undefined) && (v2 === null || v2 === undefined);
  }
  // 両方配列の場合中身を比較。
  if (Array.isArray(v1) && Array.isArray(v2)) {
    return v1.length === v2.length && v1.every((v, i) => eqLoose(v, v2[i]));
  }
  // 片方だけ配列の場合は不一致。
  if (Array.isArray(v1) || Array.isArray(v2)) {
    return false;
  }
  // objectの場合はすべてのキーで比較。
  if (v1 !== null && v2 !== null && typeof v1 === 'object' && typeof v2 === 'object') {
    return uniq([v1, v2].flatMap(getOwnKeys)).every((k) => eqLoose(v1[k], v2[k]));
  }
  // それ以外では等号で比較。（プリミティブラッパーは考慮しない。）
  return v1 === v2;
}
